import SupportModal from './support-modal';

export default SupportModal;
